/** Longest round name rendered before it is cut short — see truncateName(). */
export const MAX_ROUND_NAME_CHARS = 50;

/**
 * Hard cap on a name before it reaches the DOM.
 *
 * The rail's CSS ellipsis already handles the resizable Zoom panel, but it
 * only bounds what is *visible* — nothing bounds the string itself, so a
 * pathologically long round name is still laid out in full and read out
 * whole by screen readers. This caps the text; CSS still trims whatever the
 * panel is too narrow for. Callers keep the untruncated name in a title
 * attribute so the full value stays reachable on hover.
 */
export function truncateName(name: string, max: number = MAX_ROUND_NAME_CHARS): string {
  const trimmed = name.trim();
  if (trimmed.length <= max) return trimmed;
  // trimEnd so a cut landing on a space doesn't render as "Founders ...".
  return `${trimmed.slice(0, max).trimEnd()}...`;
}
